import { AgencyTransformer } from '@price-pages-agency-cards/src/domain/agency/agencyTransformer';
import { API_ROUTES } from '../config/apiRoutes';
export class ApiAgencyGateway {
    httpClient;
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    async getByPostalCode(postalCode, brand) {
        const response = await this.httpClient.post(`${API_ROUTES.ZIPCODE_AGENCIES_API_URL}${brand}?zipCodes=${postalCode}`);
        return response.data.agencies.map((agency) => AgencyTransformer.transform({ agency, isRecommended: true }));
    }
    // not used yet
    async getByIds(agencyIds, brand) {
        const response = await this.httpClient.get(`${API_ROUTES.AGENCIES_API_URL}${brand}`, {
            params: {
                ids: agencyIds.join(','),
            },
        });
        return response.data.agencies.map((agency) => AgencyTransformer.transform({ agency, isRecommended: false }));
    }
    async getById(id, brand, locale) {
        const response = await this.httpClient.get(`${API_ROUTES.AGENCY_API_URL}${brand}/${id}`, {
            params: {
                activeLanguage: locale,
            },
        });
        if (!response.data) {
            throw new Error(`Agency with id ${id} not found`);
        }
        return AgencyTransformer.transform({ agency: response.data, isRecommended: false });
    }
}
